import { OptionType } from 'src/templates/events'

export const getAlphaNumeric = (str: string) => str.replace(/[^a-z0-9+]+/gi, '')

export const sortLabels = (labels: OptionType[]) =>
  labels.sort((a: OptionType, b: OptionType) =>
    getAlphaNumeric(a.label).localeCompare(getAlphaNumeric(b.label))
  )
